import { render, staticRenderFns } from "./Differences.vue?vue&type=template&id=508c7f32&scoped=true&"
import script from "./Differences.vue?vue&type=script&lang=js&"
export * from "./Differences.vue?vue&type=script&lang=js&"
import style0 from "./Differences.vue?vue&type=style&index=0&id=508c7f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c7f32",
  null
  
)

export default component.exports